<template>
  <v-icon :color="color" :size="size" v-if="!iconT.custom">
    {{ iconT.src }}
  </v-icon>
  <img
    v-else
    :src="iconT.src"
    height="25"
    style="transform: scale(1.4);"
    :style="filter"
  />
</template>
<script>
import { icon } from "@/components/icon-sport/icon.js";

export default {
  name: "iconSport",
  props: {
    idSport: {},
    color: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {};
  },
  computed: {
    iconT() {
      if (!icon(this.idSport)) {
        return {};
      }

      const sportIcon = icon(this.idSport);

      if (sportIcon.custom) {
        return { custom: true, src: this.getCustomIcon(sportIcon.src) };
      }

      return { custom: false, src: sportIcon };
    },
    filter() {
      if (this.color === "primary") {
        return this.$customIconsActive(this.$vuetify.theme.themes.dark.primary);
      }

      return "";
    },
  },
  methods: {
    getCustomIcon(fileName) {
      return require("@/assets/icons/" + fileName);
    },
  },
};
</script>
